export default __webpack_public_path__ + "static/media/under_construct.474f40ff.svg";